import React, { useEffect, useState, useRef , useMemo } from 'react';
import {
  ThemeProvider,
  createTheme,
  CssBaseline,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Avatar,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  Alert,
  AlertTitle,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Badge,
  Stack,
  Drawer,
  Fab,
  useTheme,
  useMediaQuery,
  Autocomplete,
  CircularProgress,
  Backdrop,
  TablePagination,
} from '@mui/material';

import {
  Person,
  CalendarToday,
  LocationOn,
  Phone,
  Email,
  AttachMoney,
  CreditCard,
  CheckCircle,
  Description,
  Payment,
  Assignment,
  NotificationImportant,
  Visibility,
  LocalHospital,
  Science,
  LocalPharmacy,
  MoreHoriz,
  Menu as MenuIcon,
  Close,
  Search,
  FilterList as FilterListIcon,
  Clear as ClearIcon,
  Receipt as ReceiptIcon,
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import { loadPatientBill, patienHistory, loadAccountsPatients, checkPatientDischargeStatusbd, getPendingReversalsdb, getAllPendingReversalsdb } from '../BaseURL';
import PaymentsIcon from '@mui/icons-material/Payments';
import { successMessage ,formatCurrency,formatWithOutSom } from '../Message';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { Receipt } from '@mui/icons-material';
import PaymentDialog from './PaymentDialog';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import UndoIcon from '@mui/icons-material/Undo';
import ReversalDialog from '../ReversalDialog';
import ThermalReceipt from './ThermalReceipt';
import SimplePaymentAmountDialog from './SimplePaymentAmountDialog';
import { formatDateSafe } from '../Message';
import LockIcon from "@mui/icons-material/Lock";
import HotelIcon from '@mui/icons-material/Hotel';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ReplayIcon from '@mui/icons-material/Replay';
import ReversalNotificationPanel from './ReversalNotificationPanel';



const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#c44c76ff',
    },
    success: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20'
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
    },
    error: {
      main: '#d32f2f',
    },
    info: {
      main: '#0288d1',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
});

const PatientBill = ({ selectedPatient: initialPatient = {
  fullName: '',
  id: '',
  age: '',
  gender: '',
  type: '',
  tel: '',
  res: '',
  a_name: '',
  state: '',
  reg_date: new Date()

}}) => {

  const [selectedPatient, setSelectedPatient] = useState(initialPatient);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedCharges, setSelectedCharges] = useState([]);
  const [paidCharges, setPaidCharges] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showreversModal, setshowreversModal] = useState(false);
  const [transactionData, settransactionData] = useState();
  const [detailDialog, setDetailDialog] = useState({ open: false, title: '', data: [], tableType: '' });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [detailSelectedCharges, setDetailSelectedCharges] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const searchInputRef = useRef(null);
  
  // ✅ NEW STATE: Track if patient is returned to ward for discharge
  const [isReturnedToWard, setIsReturnedToWard] = useState(false);
  const [dischargeCheckLoading, setDischargeCheckLoading] = useState(false);

  const [pendingReversals, setPendingReversals]         = useState([]);
  const [reversalBadgeCount, setReversalBadgeCount]     = useState(0);
  const [reversalNotifOpen, setReversalNotifOpen]       = useState(false);
  const [reversalNotifLoading, setReversalNotifLoading] = useState(false);

  const [receiptDialog, setReceiptDialog] = useState({
  open: false,
  receiptData: null
});


const [owingPaymentDialogOpen, setOwingPaymentDialogOpen] = useState(false);
const [owingPaymentAmount, setOwingPaymentAmount] = useState('');

  // Loading states
  const [loading, setLoading] = useState(true);
  const [billsLoading, setBillsLoading] = useState(false);
  const [patientsLoading, setPatientsLoading] = useState(false);
  
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  const [currentUser ,setcurrentUser]=useState()

  useEffect(() => {
      const savedUserInfo = localStorage.getItem('userInfo');
      if (savedUserInfo) {
        const userInfo = JSON.parse(savedUserInfo);
        const userName = userInfo.name || ''; 
        setcurrentUser(userName)
      } 
    }, []);

  // Sample patient database for search functionality
  const [samplePatients, setsamplePatients] = useState([]);

  useEffect(() => {
    AllPatient();    
  }, []);

  const AllPatient = async () => {
    setPatientsLoading(true);
    try {
      const response = await axios.get(loadAccountsPatients);
      if (response.data.success) {
        setsamplePatients(response.data.results);
      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed Load Data',
        icon: 'error'
      });
    } finally {
      setPatientsLoading(false);
      setLoading(false);
    }
  };


  // Sample data with paid status
  const [serviceCharges, setServiceCharges] = useState([]);
  const [investigationCharges, setInvestigationCharges] = useState([]);
  const [medicationCharges, setMedicationCharges] = useState([]);
  const [otherCharges , setOtherCharges]=useState([])
  const [owing_bal ,setowing_bal]=useState(0.00)
  const [open, setOpen] = useState(false);


  const handleClose = () => setOpen(false);

  const handlePayOwing = () => {
  setOwingPaymentAmount('');
  setOwingPaymentDialogOpen(true);
  handleClose(); // Close the alert dialog
};

const handleProceedToOwingPayment = () => {
  if (!owingPaymentAmount || parseFloat(owingPaymentAmount) <= 0) {
    Swal.fire({
      title: 'Invalid Amount',
      text: 'Please enter a valid payment amount',
      icon: 'warning'
    });
    return;
  }

  if (parseFloat(owingPaymentAmount) > owing_bal) {
    Swal.fire({
      title: 'Amount Too High',
      text: 'Payment amount cannot exceed the outstanding balance',
      icon: 'warning'
    });
    return;
  }

  // Close amount entry dialog and open full payment dialog
  setOwingPaymentDialogOpen(false);
  setShowPaymentModal(true);
};

const loadPendingReversals = async (patientId) => {
  setReversalNotifLoading(true);
  try {
    const res = await axios.get(getPendingReversalsdb, { params: { patientId } });
    if (res.data.success) {
      setPendingReversals(res.data.results);
      setReversalBadgeCount(res.data.count);
    }
  } catch (err) {
    console.error('loadPendingReversals error:', err);
  } finally {
    setReversalNotifLoading(false);
  }
};

  // ✅ NEW FUNCTION: Check if patient is returned to ward for discharge
  const checkPatientDischargeStatus = async (patientId) => {
    setDischargeCheckLoading(true);
    try {
      const response = await axios.post(checkPatientDischargeStatusbd, {
        patientId: patientId
      });

      if (response.data.success && response.data.isReturnedToWard) {
        setIsReturnedToWard(true);
      } else {
        setIsReturnedToWard(false);
      }
    } catch (error) {
      console.error('Error checking discharge status:', error);
      setIsReturnedToWard(false);
    } finally {
      setDischargeCheckLoading(false);
    }
  };

  useEffect(() => {
  if (selectedPatient && selectedPatient.id) {
    checkPatientDischargeStatus(selectedPatient.id);
    loadBills();
    loadPatientBillHistory();
    loadPendingReversals(selectedPatient.id);
  }
}, [selectedPatient]);

  useEffect(()=>{
    if(owing_bal > 0){
      setOpen(true)
    }
  },[owing_bal])

  const loadBills = async () => {
    setBillsLoading(true);
    const id = selectedPatient.id;
    const dat = selectedPatient.reg_date;
    try {
      const response = await axios.post(loadPatientBill, {id, dat});
      if (response.data.success) {

        setServiceCharges(response.data.results);
        setInvestigationCharges(response.data.lab);
        setMedicationCharges(response.data.medication);
        setOtherCharges(response.data.other_bill)
        setowing_bal(response.data.owing_bal)

      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed to Load Data',
        icon: 'error'
      });
    } finally {
      setBillsLoading(false);
    }
  };

  const handlePatientSelect2 = (patient) => {
    setSelectedPatient(patient);
    setSearchTerm('');
    setSearchResults([]);
    setSearchOpen(false);
    // Clear current selections when switching patients
    setSelectedCharges([]);
    setDetailSelectedCharges([]);
  };

 

  const billingActions = [
    {
      id: 'generate-statement',
      title: 'Generate Statement',
      description: 'Create and send patient billing statement',
      icon: Description,
      color: 'primary',
      urgent: false
    },
    {
      id: 'process-payment',
      title: 'Process Payment',
      description: 'Record new patient payment',
      icon: CreditCard,
      color: 'success',
      urgent: false
    },
    {
      id: 'send-reminder',
      title: 'Payment Reminder',
      description: 'Send overdue payment reminder',
      icon: Email,
      color: 'warning',
      urgent: true
    },
    {
      id: 'insurance-claim',
      title: 'Submit Insurance Claim',
      description: 'Resubmit or appeal insurance claim',
      icon: Description,
      color: 'secondary',
      urgent: false
    },
    {
      id: 'payment-plan',
      title: 'Setup Payment Plan',
      description: 'Create installment payment agreement',
      icon: CalendarToday,
      color: 'info',
      urgent: false
    },
    {
      id: 'contact-patient',
      title: 'Contact Patient',
      description: 'Call patient about account balance',
      icon: Phone,
      color: 'default',
      urgent: true
    }
  ];

  const recentActivity = [
    {
      id: 1,
      action: 'Statement Generated',
      date: '2024-01-25',
      user: 'Mary Johnson',
      status: 'Completed',
      details: 'Monthly statement sent via email'
    },
    {
      id: 2,
      action: 'Payment Recorded',
      date: '2024-01-25',
      user: 'System Auto',
      status: 'Completed',
      details: 'Credit card payment of GH₵500.00'
    },
    {
      id: 3,
      action: 'Insurance Claim',
      date: '2024-01-22',
      user: 'Tom Wilson',
      status: 'Pending',
      details: 'Secondary claim submitted to UHC'
    },
    {
      id: 4,
      action: 'Payment Reminder',
      date: '2024-01-20',
      user: 'Sarah Davis',
      status: 'Completed',
      details: 'Email reminder sent for overdue balance'
    }
  ];


  const navigationTabs = [
    { id: 0, label: 'Charges & Summary', icon: <Description />, shortLabel: 'Charges' },
    { id: 1, label: 'Payment History', icon: <Payment />, shortLabel: 'Payments' },
    { id: 2, label: 'Billing Actions', icon: <Assignment />, shortLabel: 'Actions' }
  ];

  // Initialize paid charges based on status
  useEffect(() => {
    const allCharges = [...serviceCharges, ...investigationCharges, ...medicationCharges, ...otherCharges];
    const paidChargeIds = allCharges.filter(charge => charge.status === 'paid' || charge.status === 'credit').map(charge => charge.id);
    setPaidCharges(paidChargeIds);
  }, [serviceCharges, investigationCharges, medicationCharges, otherCharges]);

  // Auto-focus search input on component mount
  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

 const allCharges = [...serviceCharges, ...investigationCharges, ...medicationCharges, ...otherCharges];

  // ── Helpers defined BEFORE summaryData so they are available immediately ──
  const isChargePaid = (charge) => charge.status === 'paid' || charge.status === 'credit';

  // Expired medications are selectable (cashier can retry after stock check)
  const isChargeSelectable = (charge) =>
    charge.status !== 'paid' && charge.status !== 'credit';

  // Coerce anything that came back from the API into a usable number.
  //
  // Prevents: GH¢NaN across the whole summary row.
  //
  // These reducers used `sum + charge.total` with no guard. The charges come
  // from four different tables via /loadPatientBill, and a single row whose
  // `total` is null, undefined or a non-numeric string turns the running sum
  // into NaN — which then propagates through every remaining row. One bad
  // charge blanked out Total Charges, Total Payment and Outstanding Balance
  // at once, while Adjustments stayed correct purely because it happened to
  // have a `|| 0` fallback.
  //
  // `|| 0` is not enough on its own either: a numeric STRING like '5' is
  // truthy, so `sum + '5'` silently switches to string concatenation and the
  // total becomes '05'. Parsing to a real number is the only safe form.
  const toAmount = (v) => {
    if (v === null || v === undefined) return 0;
    const n = typeof v === 'number' ? v : parseFloat(String(v).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(n) ? n : 0;
  };

  const isSettled = (charge) => charge.status === 'paid' || charge.status === 'credit';
  const sumTotals = (list) => list.reduce((sum, charge) => sum + toAmount(charge.total), 0);

  // Calculate totals
  const totalChargesValue  = sumTotals(allCharges);
  const patientPaidValue   = sumTotals(allCharges.filter(isSettled));

  const summaryData = {
    totalCharges: totalChargesValue,
    patientPayments: patientPaidValue,
    adjustments: allCharges.reduce((sum, charge) => sum + toAmount(charge.discount), 0),
    TotalDebit: totalChargesValue - patientPaidValue,
    outstandingBalance: sumTotals(allCharges.filter(isChargeSelectable)),
  };

  const handleChargeSelection = (chargeIds) => {
    setSelectedCharges(chargeIds);
  };

  const handleCheckboxChange = (chargeId, checked) => {
    const charge = allCharges.find(c => c.id === chargeId);
    if (charge && (charge.status === 'paid' || charge.status === 'credit')) return; // Don't allow changes to paid/credit charges
    
    if (checked) {
      handleChargeSelection([...selectedCharges, chargeId]);
    } else {
      handleChargeSelection(selectedCharges.filter(id => id !== chargeId));
    }
  };

  const handleDetailCheckboxChange = (chargeId, checked) => {
  const charge = detailDialog.data.find(c => c.id === chargeId);
  if (charge && !isChargeSelectable(charge)) return;
    
    if (checked) {
      setDetailSelectedCharges([...detailSelectedCharges, chargeId]);
      setSelectedCharges([...selectedCharges, chargeId]);
    } else {
      setDetailSelectedCharges(detailSelectedCharges.filter(id => id !== chargeId));
      setSelectedCharges(selectedCharges.filter(id => id !== chargeId));
    }
  };

  // Enhanced table-specific select all logic
  const handleTableSelectAll = (checked, tableData, tableType) => {
  const unpaidTableCharges = tableData.filter(charge => isChargeSelectable(charge));
    const unpaidTableChargeIds = unpaidTableCharges.map(charge => charge.id);
    
    if (checked) {
      // Add all unpaid charges from this table to selection
      const newSelection = [...new Set([...selectedCharges, ...unpaidTableChargeIds])];
      handleChargeSelection(newSelection);
    } else {
      // Remove all charges from this table from selection
      const newSelection = selectedCharges.filter(id => !unpaidTableChargeIds.includes(id));
      handleChargeSelection(newSelection);
    }
  };

  // Enhanced table-specific cancellation logic
  const handleTableCancelSelection = (tableData, tableType) => {
    const tableChargeIds = tableData.map(charge => charge.id);
    const newSelection = selectedCharges.filter(id => !tableChargeIds.includes(id));
    handleChargeSelection(newSelection);
  };

  // Get table-specific selection state
  const getTableSelectionState = (tableData) => {
    const unpaidTableCharges = tableData.filter(charge => charge.status !== 'paid' && charge.status !== 'credit');
    const unpaidTableChargeIds = unpaidTableCharges.map(charge => charge.id);
    
    const selectedFromTable = unpaidTableChargeIds.filter(id => selectedCharges.includes(id));
    
    return {
      allSelected: unpaidTableCharges.length > 0 && selectedFromTable.length === unpaidTableCharges.length,
      someSelected: selectedFromTable.length > 0 && selectedFromTable.length < unpaidTableCharges.length,
      selectedCount: selectedFromTable.length,
      totalUnpaid: unpaidTableCharges.length,
      selectedTotal: tableData.filter(charge => selectedCharges.includes(charge.id)).reduce((sum, charge) => sum + (parseFloat(charge.total) || 0), 0)
    };
  };



  const selectedTotal = allCharges
    .filter(charge => selectedCharges.includes(charge.id))
    .reduce((sum, charge) => sum + (parseFloat(charge.total) || 0), 0);


const handleSelectAllPending = () => {
  const allSelectableCharges = allCharges.filter(charge => isChargeSelectable(charge));
  const allSelectableIds = allSelectableCharges.map(charge => charge.id);
  setSelectedCharges(allSelectableIds);
};

const handleCancelSelectedPending = () => {
  setSelectedCharges([]);
  setDetailSelectedCharges([]);
};

const totalPendingAmount = allCharges
  .filter(charge => isChargeSelectable(charge))
  .reduce((sum, charge) => sum + (parseFloat(charge.total) || 0), 0);

  const getStatusChip = (status) => {
  const statusConfig = {
    'paid':    { color: 'success', variant: 'filled' },
    'credit':  { color: 'success', variant: 'filled' },
    'pending': { color: 'warning', variant: 'filled' },
    'expired': { color: 'error',   variant: 'outlined' },
  };

  const config = statusConfig[status] || { color: 'default', variant: 'outlined' };
  return (
    <Chip
      label={status.charAt(0).toUpperCase() + status.slice(1)}
      color={config.color}
      variant={config.variant}
      size="small"
      sx={status === 'expired' ? { borderStyle: 'dashed', fontWeight: 700 } : {}}
    />
  );
};

  
  const openDetailDialog = (title, data, tableType) => {
    setDetailDialog({ open: true, title, data, tableType });
    // Initialize detail selected charges with already selected charges from this table
    const tableChargeIds = data.map(charge => charge.id);
    const tableSelectedCharges = selectedCharges.filter(id => tableChargeIds.includes(id));
    setDetailSelectedCharges(tableSelectedCharges);
  };


  const getTableTotal = (data) => {
    // Force numeric add — backend returns DECIMAL columns as strings, so a
    // raw `sum + item.total` concatenates instead of adding and the result
    // is a string. parseFloat() with a 0 fallback keeps NaN/undefined/null
    // from poisoning the running total.
    return data.reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0);
  };


 const handlePatientSearch = (searchValue) => {
  if (!searchValue || searchValue.length < 1) {
    setSearchResults([]);
    setSearchOpen(false);
    return;
  }

  setSearchLoading(true);

  setTimeout(() => {
    try {
      const searchLower = searchValue.toLowerCase();
      const searchTrimmed = searchValue.trim();
      const isNumericSearch = /^\d+$/.test(searchTrimmed);

      const results = samplePatients
        .filter(patient => {
          // ✅ Safely access properties with null checks
          const patientIdLower = (patient.id || '').toLowerCase();
          const fullNameLower = (patient.fullName || '').toLowerCase();
          const aNameLower = (patient.a_name || '').toLowerCase();
          const telLower = (patient.tel || '').toLowerCase();
          
          const hasTextMatch = (
            patientIdLower.includes(searchLower) ||
            fullNameLower.includes(searchLower) ||
            aNameLower.includes(searchLower) ||
            telLower.includes(searchLower)
          );
          
          if (isNumericSearch) {
            const idNumbers = patient.id?.match(/\d+/g) || [];
            const hasNumberMatch = idNumbers.some(num => {
              return num.includes(searchTrimmed);
            });
            
            return hasTextMatch || hasNumberMatch;
          }
          
          return hasTextMatch;
        })
        .sort((a, b) => {
          // ✅ Add null checks in sorting
          const aIdLower = (a.id || '').toLowerCase();
          const bIdLower = (b.id || '').toLowerCase();
          const aNameLower = (a.fullName || '').toLowerCase();
          const bNameLower = (b.fullName || '').toLowerCase();
          const aRefLower = (a.a_name || '').toLowerCase();
          const bRefLower = (b.a_name || '').toLowerCase();

          const aExactId = aIdLower === searchLower;
          const bExactId = bIdLower === searchLower;
          if (aExactId && !bExactId) return -1;
          if (!aExactId && bExactId) return 1;

          const aExactName = aNameLower === searchLower;
          const bExactName = bNameLower === searchLower;
          if (aExactName && !bExactName) return -1;
          if (!aExactName && bExactName) return 1;

          const aExactRef = aRefLower === searchLower;
          const bExactRef = bRefLower === searchLower;
          if (aExactRef && !bExactRef) return -1;
          if (!aExactRef && bExactRef) return 1;

          if (isNumericSearch) {
            const aIdNumbers = a.id?.match(/\d+/g) || [];
            const bIdNumbers = b.id?.match(/\d+/g) || [];
            const searchNumInt = parseInt(searchValue);
            
            const aHasExactNumber = aIdNumbers.some(num => parseInt(num) === searchNumInt);
            const bHasExactNumber = bIdNumbers.some(num => parseInt(num) === searchNumInt);
            
            if (aHasExactNumber && !bHasExactNumber) return -1;
            if (!aHasExactNumber && bHasExactNumber) return 1;
            
            const aHasStartingNumber = aIdNumbers.some(num => num.startsWith(searchValue));
            const bHasStartingNumber = bIdNumbers.some(num => num.startsWith(searchValue));
            
            if (aHasStartingNumber && !bHasStartingNumber) return -1;
            if (!aHasStartingNumber && bHasStartingNumber) return 1;
          }

          const aIdStarts = aIdLower.startsWith(searchLower);
          const bIdStarts = bIdLower.startsWith(searchLower);
          if (aIdStarts && !bIdStarts) return -1;
          if (!aIdStarts && bIdStarts) return 1;

          if (isNumericSearch) {
            const searchNumInt = parseInt(searchTrimmed);
            const aIdNum = parseFloat((a.id || '').replace(/[^\d]/g, ''));
            const bIdNum = parseFloat((b.id || '').replace(/[^\d]/g, ''));

            if (!isNaN(aIdNum) && !isNaN(bIdNum)) {
              const aDiff = Math.abs(aIdNum - searchNumInt);
              const bDiff = Math.abs(bIdNum - searchNumInt);
              if (aDiff !== bDiff) {
                return aDiff - bDiff;
              }
            }
          }

          const aNameStarts = aNameLower.startsWith(searchLower);
          const bNameStarts = bNameLower.startsWith(searchLower);
          if (aNameStarts && !bNameStarts) return -1;
          if (!aNameStarts && bNameStarts) return 1;

          const aRefStarts = aRefLower.startsWith(searchLower);
          const bRefStarts = bRefLower.startsWith(searchLower);
          if (aRefStarts && !bRefStarts) return -1;
          if (!aRefStarts && bRefStarts) return 1;

          return aNameLower.localeCompare(bNameLower);
        })
        .slice(0, 15);

      setSearchResults(results);
      setSearchLoading(false);

      if (results.length > 0) {
        setSearchOpen(true);
      }
    } catch (error) {
      console.error('Search error:', error);
      setSearchResults([]);
      setSearchLoading(false);
      setSearchOpen(false);
    }
  }, 100);
};

  useEffect(() => {
  if (!searchTerm || searchTerm.length < 1) {
    setSearchResults([]);
    setSearchOpen(false);
    setSearchLoading(false);
    return;
  }

  const timeoutId = setTimeout(() => {
    handlePatientSearch(searchTerm);
  }, 300);

  return () => {
    clearTimeout(timeoutId);
    setSearchLoading(false);
  };
}, [searchTerm, samplePatients]);



  // Floating Navigation Component
  const FloatingNavigation = () => (
    <>
      {/* Desktop Floating Tabs */}
      {!isMobile && (
        <>
        <Fab
            color="primary"
            onClick={() => setDrawerOpen(true)}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 1050,
              boxShadow: '0 8px 32px rgba(25, 118, 210, 0.3)'
            }}
          >
            <MenuIcon />
          </Fab>

          <Drawer
            anchor="bottom"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            PaperProps={{
              sx: {
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                maxHeight: '50vh'
              }
            }}
          >
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                Navigation
              </Typography>
              <Stack spacing={1}>
                {navigationTabs.map((tab) => (
                  <Button
                    key={tab.id}
                    onClick={() => {
                      setActiveTab(tab.id);
                      setDrawerOpen(false);
                    }}
                    startIcon={tab.icon}
                    fullWidth
                    sx={{
                      justifyContent: 'flex-start',
                      px: 2,
                      py: 1.5,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: activeTab === tab.id ? 600 : 400,
                      bgcolor: activeTab === tab.id ? 'primary.main' : 'transparent',
                      color: activeTab === tab.id ? 'primary.contrastText' : 'text.primary',
                      '&:hover': {
                        bgcolor: activeTab === tab.id ? 'primary.dark' : 'action.hover',
                      }
                    }}
                  >
                    {tab.label}
                  </Button>
                ))}
              </Stack>
            </Box>
          </Drawer>
        </>
      )}

      {/* Mobile Floating Navigation */}
      {isMobile && (
        <>
          <Fab
            color="primary"
            onClick={() => setDrawerOpen(true)}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 1000,
              boxShadow: '0 8px 32px rgba(25, 118, 210, 0.3)'
            }}
          >
            <MenuIcon />
          </Fab>

          <Drawer
            anchor="bottom"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            PaperProps={{
              sx: {
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                maxHeight: '50vh'
              }
            }}
          >
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                Navigation
              </Typography>
              <Stack spacing={1}>
                {navigationTabs.map((tab) => (
                  <Button
                    key={tab.id}
                    onClick={() => {
                      setActiveTab(tab.id);
                      setDrawerOpen(false);
                    }}
                    startIcon={tab.icon}
                    fullWidth
                    sx={{
                      justifyContent: 'flex-start',
                      px: 2,
                      py: 1.5,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: activeTab === tab.id ? 600 : 400,
                      bgcolor: activeTab === tab.id ? 'primary.main' : 'transparent',
                      color: activeTab === tab.id ? 'primary.contrastText' : 'text.primary',
                      '&:hover': {
                        bgcolor: activeTab === tab.id ? 'primary.dark' : 'action.hover',
                      }
                    }}
                  >
                    {tab.label}
                  </Button>
                ))}
              </Stack>
            </Box>
          </Drawer>
        </>
      )}
    </>
  );

  // Enhanced Reusable Table Component with improved selection logic
  const BillingTable = ({ title, data, tableType, icon, color = 'primary' }) => {
    const tableSelectionState = getTableSelectionState(data);
    const tableTotal = getTableTotal(data);
    
    // Calculate table-specific totals. Coerce charge.total to a number on
    // every step so a string value from the backend can't turn the reduce
    // into a string concatenation.
    const tablePaidTotal = data.filter(charge => charge.status === 'paid' || charge.status === 'credit').reduce((sum, charge) => sum + (parseFloat(charge.total) || 0), 0);
    const tablePendingTotal = data.filter(charge => charge.status !== 'paid' && charge.status !== 'credit').reduce((sum, charge) => sum + (parseFloat(charge.total) || 0), 0);
    const tableBalance = tablePendingTotal;

    return (
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: `${color}.main` }}>
              {icon}
            </Avatar>
          }
          title={<Typography variant="h6" fontWeight="bold">{title}</Typography>}
          subheader={`${data.length} items • GH₵${tableTotal.toFixed(2)}`}
          action={
            <Box display="flex" alignItems="center" gap={1}>
              {tableSelectionState.selectedTotal > 0 && (
                <Chip 
                  label={`GH₵${tableSelectionState.selectedTotal.toFixed(2)} selected`}
                  color="primary" 
                  size="small"
                />
              )}
              {tableSelectionState.selectedCount > 0 && (
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => handleTableCancelSelection(data, tableType)}
                  startIcon={<Close />}
                  sx={{ ml: 1 }}
                >
                  Clear ({tableSelectionState.selectedCount})
                </Button>
              )}
            </Box>
          }
        />
        <CardContent sx={{ flex: 1, pt: 0 }}>
          <TableContainer sx={{ maxHeight: 300, overflow: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={tableSelectionState.allSelected}
                      indeterminate={tableSelectionState.someSelected}
                      onChange={(e) => handleTableSelectAll(e.target.checked, data, tableType)}
                      disabled={tableSelectionState.totalUnpaid === 0}
                    />
                  </TableCell>
                  <TableCell><Typography variant="body2" fontWeight="bold">Date</Typography></TableCell>
                  <TableCell><Typography variant="body2" fontWeight="bold">Description</Typography></TableCell>
                  <TableCell align="right"><Typography variant="body2" fontWeight="bold">Amount</Typography></TableCell>
                  <TableCell align="center"><Typography variant="body2" fontWeight="bold">Status</Typography></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((charge) => (
                  <TableRow
                    key={charge.id}
                     sx={{
                      bgcolor: isChargePaid(charge) ? '#f0f8f0' : 'inherit',
                      '& td, & th': {
                        color: isChargePaid(charge) ? '' : '',
                      },
                      '&:hover': { 
                        bgcolor: isChargePaid(charge) ? '#f0f8f0' : 'grey.50',
                      },
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedCharges.includes(charge.id) || isChargePaid(charge)}
                        onChange={(e) => handleCheckboxChange(charge.id, e.target.checked)}
                        disabled={!isChargeSelectable(charge)}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight="600">
                        {formatDateSafe(charge.date)}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ maxWidth: 200 }}>
                      <Typography 
                        variant="body2" 
                        fontWeight="600"
                        sx={{ 
                          wordWrap: 'break-word',
                          whiteSpace: 'normal',
                          lineHeight: 1.3
                        }}
                      >
                        {charge.description}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" fontWeight="500">
                        {charge.code}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontWeight="bold">
                        {formatWithOutSom(charge.total)}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      {getStatusChip(charge.status)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          <Divider sx={{ my: 2 }} />
          
          {/* Enhanced Table Summary with Selection Info */}
          <Box sx={{ bgcolor: 'grey.50', p: 2, borderRadius: 1 }}>
            {/* Selection Status Row */}
            {tableSelectionState.selectedCount > 0 && (
              <Box sx={{ mb: 2, p: 1, bgcolor: 'primary.light', borderRadius: 1 }}>
                <Typography variant="body2" color="primary.contrastText" fontWeight="bold">
                  {tableSelectionState.selectedCount} of {tableSelectionState.totalUnpaid} unpaid items selected
                  {tableSelectionState.selectedTotal > 0 && ` • GH₵${tableSelectionState.selectedTotal.toFixed(2)}`}
                </Typography>
              </Box>
            )}
            
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={4}>
                <Box textAlign="center">
                  <Typography variant="caption" color="text.secondary" fontWeight="bold">
                    paid/Credit
                  </Typography>
                  <Typography variant="body2" fontWeight="bold" color="success.main">
                    {tablePaidTotal.toFixed(2)}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box textAlign="center">
                  <Typography variant="caption" color="text.secondary" fontWeight="bold">
                    pending
                  </Typography>
                  <Typography variant="body2" fontWeight="bold" color="warning.main">
                    {tablePendingTotal.toFixed(2)}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box textAlign="center">
                  <Typography variant="caption" color="text.secondary" fontWeight="bold">
                    Balance
                  </Typography>
                  <Typography variant="body2" fontWeight="bold" color="error.main">
                    {tableBalance.toFixed(2)}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" fontWeight="bold">
                Total: GH₵{tableTotal.toFixed(2)}
              </Typography>
              <Box display="flex" gap={1}>
                {tableSelectionState.totalUnpaid > 0 && (
                  <Button
                    startIcon={<CheckCircle />}
                    onClick={() => handleTableSelectAll(true, data, tableType)}
                    size="small"
                    variant="outlined"
                    color="primary"
                    disabled={tableSelectionState.allSelected}
                  >
                    Select All Unpaid
                  </Button>
                )}
                <Button
                  startIcon={<Visibility />}
                  onClick={() => openDetailDialog(title, data, tableType)}
                  size="small"
                  variant="outlined"
                >
                  View Details
                </Button>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };

  // Enhanced Patient Search Component with Focus Improvements
  const PatientSearch = () => (
    <Card elevation={2} sx={{ mb: 3 }}>
      <CardContent sx={{ py: 2 }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Autocomplete
            fullWidth
            freeSolo
            open={searchOpen}
            onOpen={() => {
              if (searchResults.length > 0 && searchTerm.length > 1) {
                setSearchOpen(true);
              }
            }}
            onClose={() => setSearchOpen(false)}
            inputValue={searchTerm}
            onInputChange={(event, newInputValue) => {
              setSearchTerm(newInputValue);
              if (newInputValue.length < 2) {
                setSearchOpen(false);
                setSearchResults([]);
              }
            }}
            options={searchResults}
            loading={searchLoading}
            getOptionLabel={(option) => {
              if (typeof option === 'string') return option;
              return `${option.fullName} (${option.id})`;
            }}
           renderOption={(props, option) => (
  <Box 
    component="li" 
    {...props}
    onClick={() => handlePatientSelect2(option)}
    sx={{ 
      borderBottom: '1px solid',
      borderColor: 'divider',
      '&:last-child': { borderBottom: 'none' },
      p: 2,
      cursor: 'pointer',
      '&:hover': { bgcolor: 'action.hover' }
    }}
  >
    <Box display="flex" alignItems="center" gap={2} width="100%">
      <Avatar sx={{ bgcolor: 'primary.main' }}>
        <Person />
      </Avatar>
      <Box flex={1}>
        <Typography variant="body1" fontWeight="bold">
          {option.fullName || 'Unknown'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Id: {option.id || 'N/A'} {option.a_name && `• Ref: ${option.a_name}`}
        </Typography>
        <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
          {option.gender && <Chip size="small" label={option.gender} />}
          {option.type && <Chip size="small" label={option.type} />}
          {option.state && (
            <Chip 
              size="small" 
              label={option.state} 
              color={option.state === 'inpatient' ? 'success' : 'warning'}
            />
          )}
          {option.source && (
            <Chip 
              size="small" 
              label={option.source} 
              color={option.source === 'bill_me' ? 'secondary' : 'default'}
            />
          )}
        </Stack>
      </Box>
      <Box textAlign="right">
        <Typography variant="body2" color="text.secondary">
          {option.tel || 'No Phone'}
        </Typography>
        {option.age && (
          <Typography variant="caption" color="text.secondary">
            Age: {option.age}
          </Typography>
        )}
      </Box>
    </Box>
  </Box>
)}
            renderInput={(params) => (
              <TextField
                {...params}
                inputRef={searchInputRef}
                placeholder="Search for patients by ID, Name, Tel #........"
                variant="outlined"
                size="big"
                autoFocus
                InputProps={{
                  ...params.InputProps,
                  startAdornment: <Search sx={{ color: 'action.active', mr: 1 }} />,
                  endAdornment: (
                    <>
                      {searchLoading ? <CircularProgress color="inherit" size={25} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handlePatientSearch();
                  }
                }}
                  onFocus={() => {
                if (searchResults.length > 0 && searchTerm.length > 1) {
                  setSearchOpen(true);
                }
              }}
              />
            )}
          />
        </Box>
      </CardContent>
    </Card>
  );

const PatientHeader = () => {
  // Handle case when no patient is selected
  if (!selectedPatient || !selectedPatient.fullName) {
    return (
      <Card elevation={2} sx={{ mb: 3 }}>
        <CardContent sx={{ p: 3, textAlign: 'center' }}>
          <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            <Avatar
              sx={{ 
                width: 64, 
                height: 64, 
                bgcolor: 'grey.400',
                fontSize: '1.5rem'
              }}
            >
              <Person />
            </Avatar>
            <Box>
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No Patient Selected
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Please search and select a patient to view billing information
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  }

  // Helper function to get initials safely
  const getInitials = (name) => {
    if (!name || typeof name !== 'string') return '??';
    return name
      .split(' ')
      .filter(part => part.length > 0)
      .map(part => part[0])
      .join('')
      .toUpperCase();
  };

  // Helper function to format date safely
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return formatDateSafe(dateString);
    } catch (error) {
      return 'Invalid Date';
    }
  };

  return (
    <>
      {/* ✅ Discharge Warning Banner - TOP OF PAGE */}
      {isReturnedToWard && (
        <Alert 
          severity="error" 
          variant="filled"
          sx={{
            mb: 3,
            p: 3,
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(211, 47, 47, 0.4)',
            border: '3px solid',
            borderColor: 'error.dark',
            position: 'relative',
            overflow: 'hidden'
          }}
          icon={false}
        >
          {/* Animated background pattern */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)',
              animation: 'moveStripes 20s linear infinite',
              '@keyframes moveStripes': {
                '0%': { backgroundPosition: '0 0' },
                '100%': { backgroundPosition: '70px 70px' }
              }
            }}
          />

          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Grid container spacing={3} alignItems="center">
              {/* Icon Section */}
              <Grid item xs={12} sm={2} sx={{ textAlign: 'center' }}>
                <Box
                  sx={{
                    bgcolor: 'white',
                    borderRadius: '50%',
                    width: 80,
                    height: 80,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                  }}
                >
                  <HotelIcon sx={{ fontSize: 50, color: 'error.main' }} />
                </Box>
              </Grid>

              {/* Main Message Section */}
              <Grid item xs={12} sm={7}>
                <Typography variant="h4" fontWeight={900} gutterBottom sx={{ color: 'white' }}>
                  ⚠️ BILLING COMPLETED - PATIENT RETURNED TO WARD
                </Typography>
                
                <Box 
                  sx={{ 
                    bgcolor: 'rgba(255, 255, 255, 0.2)', 
                    p: 2, 
                    borderRadius: 1,
                    mb: 2
                  }}
                >
                  <Typography variant="h6" fontWeight={700} sx={{ color: 'white' }}>
                    🔒 ALL BILLING ACTIONS ARE NOW LOCKED
                  </Typography>
                </Box>

                <Typography variant="body1" fontWeight={600} sx={{ color: 'white' }}>
                  <strong>Next Steps:</strong> Ward Discharge → Bed Clearance → Nursing Documentation → Patient Release
                </Typography>
              </Grid>

              {/* Status Badge Section */}
              <Grid item xs={12} sm={3} sx={{ textAlign: 'center' }}>
                <Box
                  sx={{
                    bgcolor: 'white',
                    color: 'error.main',
                    p: 2,
                    borderRadius: 2,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                  }}
                >
                  <LockIcon sx={{ fontSize: 40, mb: 1 }} />
                  <Typography variant="h6" fontWeight={700}>
                    LOCKED
                  </Typography>
                  <Typography variant="caption" display="block" fontWeight={600}>
                    No Further Billing
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Alert>
      )}

      {/* Patient Information Card */}
      <Card elevation={2} sx={{ mb: 3 }}>
        <CardContent 
          sx={{ 
            p: 3,
            opacity: isReturnedToWard ? 0.6 : 1,
            pointerEvents: isReturnedToWard ? 'none' : 'auto',
            transition: 'opacity 0.3s ease'
          }}
        >
          <Grid container spacing={3} sx={{ width: '100%' }}>
            {/* Patient Basic Info */}
            <Grid item xs={12} sm={6} md sx={{ flexGrow: 1 }}>
              <Box display="flex" alignItems="flex-start" gap={2}>
                <Avatar
                  sx={{ 
                    width: 64, 
                    height: 64, 
                    bgcolor: 'primary.main',
                    fontSize: '1.5rem',
                    fontWeight: 'bold'
                  }}
                >
                  {getInitials(selectedPatient.fullName)}
                </Avatar>
                <Box flex={1}>
                  <Typography variant="h6" component="h2" gutterBottom>
                    {selectedPatient.fullName || 'Unknown Patient'} 
                    {selectedPatient.id && ` (${selectedPatient.id})`}
                  </Typography>
                  
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }}>
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <CalendarToday fontSize="small" color="action" />
                      <Typography variant="body2">
                        Age: {selectedPatient.age || 'N/A'} Year(s)
                      </Typography>
                    </Box>
                  </Stack>
                  
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} mt={1}>
                    {selectedPatient.gender && (
                      <Box>
                        <Chip 
                          label={selectedPatient.gender} 
                          color="error" 
                          variant="filled" 
                          size="small"
                        />
                      </Box>
                    )}
                    {selectedPatient.type && (
                      <Box>
                        <Chip 
                          label={selectedPatient.type} 
                          color="warning" 
                          variant="filled" 
                          size="small"
                        />
                      </Box>
                    )}
                  </Stack>
                </Box>
              </Box>
            </Grid>
            

            {/* Contact Information */}
            <Grid item xs={12} sm={6} md sx={{ flexGrow: 1 }}>
              <Typography variant="h6" gutterBottom>Contact Information</Typography>
              <Stack spacing={1}>
                {selectedPatient.tel && (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Phone fontSize="small" color="action" />
                    <Typography variant="body2">{selectedPatient.tel}</Typography>
                  </Box>
                )}
                {selectedPatient.a_name && (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Email fontSize="small" color="action" />
                    <Typography variant="body2">Reference: {selectedPatient.a_name}</Typography>
                  </Box>
                )}
                {selectedPatient.res && (
                  <Box display="flex" alignItems="center" gap={1}>
                    <LocationOn fontSize="small" color="action" />
                    <Typography variant="body2">{selectedPatient.res}</Typography>
                  </Box>
                )}
                
                {/* Show placeholder if no contact info */}
                {!selectedPatient.tel && !selectedPatient.a_name && !selectedPatient.res && (
                  <Typography variant="body2" color="text.secondary" fontStyle="italic">
                    No contact information available
                  </Typography>
                )}
              </Stack>
            </Grid>

            {/* Status and Visit Info */}
            <Grid item xs={12} sm={6} md sx={{ flexGrow: 1 }}>
              <Box textAlign={{ xs: 'left', md: 'right' }}>
                {selectedPatient.state && (
                  <Chip 
                    label={selectedPatient.state} 
                    color={selectedPatient.state === 'Active' ? 'success' : 'default'}
                    variant="filled" 
                    sx={{ mb: 2 }}
                  />
                )}
                
                <Typography variant="body2" color="text.secondary">
                  <strong>Visit Date:</strong> {formatDate(selectedPatient.reg_date)}
                </Typography>
                
                {selectedPatient.id && (
                  <Typography variant="body2" color="text.secondary">
                    <strong>Patient ID:</strong> {selectedPatient.id}
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

const BillingSummary = () => (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={3} sx={{ mb: 3, width: '100%' }}>
        <Grid item xs={12} sm={6} md sx={{ flexGrow: 1 }}>
          <Card sx={{ bgcolor: 'primary.light', color: 'primary.contrastText' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1}>
                <Box>
                  <Typography variant="caption">Total Charges</Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {formatCurrency(summaryData.totalCharges)}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md sx={{ flexGrow: 1 }}>
          <Card sx={{ bgcolor: 'secondary.light', color: 'secondary.contrastText' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1}>
                <Box>
                  <Typography variant="caption">Total Payment</Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {formatCurrency(summaryData.patientPayments)}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

       
        <Grid item xs={12} sm={6} md sx={{ flexGrow: 1 }}>
         <Card sx={{bgcolor: 'success.light', color: 'primary.contrastText' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1}>
                <Box>
                  <Typography variant="caption"> Adjustments</Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {formatCurrency(summaryData.adjustments)}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md sx={{ flexGrow: 1 }}>
          <Card sx={{ bgcolor: 'error.light', color: 'error.contrastText' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1}>
                <Box>
                  <Typography variant="caption">Outstanding Balance</Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {formatCurrency(summaryData.outstandingBalance)}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>


         <Grid item xs={12} sm={6} md sx={{ flexGrow: 1 }}>
          <Card sx={{bgcolor: 'secondary.main', color: 'primary.contrastText' }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1}>
                <Box>
                  <Typography variant="caption">Debit Balance / Owing</Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {formatCurrency(owing_bal)}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
);

const ChargesTable = () => (
    <Box>
      {/* Quick Actions and Selected for Payment on the same row */}
      {(totalPendingAmount > 0 || selectedCharges.length > 0) && (
        <Box display="flex" gap={3} width="100%" sx={{ mb: 3 }}>
          {/* Quick Actions Card */}
          {totalPendingAmount > 0 && (
            <Box flex={selectedCharges.length > 0 ? 1 : "100%"}>
              <Card 
                variant="outlined" 
                sx={{ 
                  bgcolor: '#f6f6f6', 
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'success.light'
                }}
              >
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ height: '100%' }}>
                    <Box>
                      <Typography variant="h6">Quick Actions</Typography>
                      <Typography variant="body2">
                        Total pending amount: GH₵{totalPendingAmount.toFixed(2)}
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSelectAllPending}
                      startIcon={<CheckCircle />}
                      sx={{ 
                        bgcolor: 'white',
                        color: 'primary.main',
                        '&:hover': {
                          bgcolor: 'grey.100'
                        }
                      }}
                    >
                      Select All Pending
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          )}

          {/* Selected for Payment Card */}
          {selectedCharges.length > 0 && (
            <Box flex={totalPendingAmount > 0 ? 1 : "100%"}>
              <Card 
                variant="outlined" 
                sx={{ 
                  bgcolor: '#f6f6f6', 
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'success.light'
                }}
              >
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ height: '100%' }}>
                    <Box>
                      <Typography variant="h6">Selected for Payment</Typography>
                      <Typography variant="body2">
                        {selectedCharges.length} item{selectedCharges.length > 1 ? 's' : ''} selected
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box textAlign="right">
                        <Typography variant="h5" fontWeight="bold">
                          GH₵{selectedTotal.toFixed(2)}
                        </Typography>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => setShowPaymentModal(true)}
                          startIcon={<Payment />}
                          sx={{ mt: 1 }}
                        >
                          Process Payment
                        </Button>
                      </Box>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={handleCancelSelectedPending}
                        startIcon={<Close />}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          )}
        </Box>
      )}


      {/* Four Tables in 2x2 Grid */}
      <Grid container spacing={3} sx={{ mb: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid item xs={12} md={6} size={6}>
          <BillingTable
            title="Service Charges"
            data={serviceCharges}
            tableType="services"
            icon={<LocalHospital />}
            color="primary"
          />
        </Grid>
        
        <Grid item xs={12} md={6} size={6}>
          <BillingTable
            title="Investigation Charges"
            data={investigationCharges}
            tableType="investigations"
            icon={<Science />}
            color="info"
          />
        </Grid>
        
        <Grid item xs={12} md={6} size={6}>
          <BillingTable
            title="Medication Charges"
            data={medicationCharges}
            tableType="medications"
            icon={<LocalPharmacy />}
            color="success"
          />
        </Grid>
        
        <Grid item xs={12} md={6} size={6}>
          <BillingTable
            title="Other Charges"
            data={otherCharges}
            tableType="other"
            icon={<MoreHoriz />}
            color="secondary"
          />
        </Grid>
      </Grid>
    </Box>
);

const [data ,setdata] = useState([]);


const loadPatientBillHistory = async () => {
    setBillsLoading(true);
    const id = selectedPatient.id;
    try {
      const response = await axios.post(patienHistory, {id});
      if (response.data.success) {

        setdata(response.data.results);

      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Failed to Load Data',
        icon: 'error'
      });
    } finally {
      setBillsLoading(false);
    }
  };



const PaymentHistory = () => {
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Filter data based on date range
  const filteredData = useMemo(() => {
    if (!startDate && !endDate) return data;
    
    return data.filter(row => {
      const rowDate = dayjs(row.date);
      
      if (startDate && endDate) {
        return rowDate.isAfter(startDate.subtract(1, 'day')) && rowDate.isBefore(endDate.add(1, 'day'));
      } else if (startDate) {
        return rowDate.isAfter(startDate.subtract(1, 'day'));
      } else if (endDate) {
        return rowDate.isBefore(endDate.add(1, 'day'));
      }
      return true;
    });
  }, [data, startDate, endDate]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditClick = (rowId) => {
    console.log('Edit clicked for row:', rowId);
    // Add your edit logic here
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'paid':
        return 'success';
      case 'pending':
        return 'warning';
      case 'overdue':
        return 'error';
      case 'cancelled':
        return 'default';
      default:
        return 'default';
    }
  };

  const clearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setPage(0);
  };

  const formatDate = (dateString) => {
    return dayjs(dateString).format('MMM DD, YYYY');
  };

 const openreversal=(transactionData)=>{
   settransactionData(transactionData)
   console.log(transactionData)
  setshowreversModal(true)
}


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom fontWeight="medium">
            Patient Bill History
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage and track patient billing records with advanced filtering options
          </Typography>
        </Box>
        
        {/* Date Filter Section */}
        <Card sx={{ mb: 3, elevation: 2 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <FilterListIcon sx={{ mr: 1, color: 'primary.main' }} />
              <Typography variant="h6" component="h2">
                Filter Options
              </Typography>
            </Box>
            
             <Grid container spacing={3} sx={{ mb: 3, width: '100%' }}>
              <Grid item xs={12} sm={6} >
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  maxDate={dayjs()}
                />
              </Grid>
              
              <Grid item xs={12} sm={6} >
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  maxDate={dayjs()}
                  minDate={startDate}
                />
              </Grid>
              
              
              <Grid item xs={12} sm={6} >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={clearFilters}
                  startIcon={<ClearIcon />}
                  fullWidth
                  sx={{ height: 56 }}
                >
                  Clear Filters
                </Button>
              </Grid>
            </Grid>
            
            {(startDate || endDate) && (
              <Box sx={{ mt: 2, p: 2, bgcolor: 'primary.light', borderRadius: 1 }}>
                <Typography variant="body2" color="primary.contrastText">
                  <strong>Filter Results:</strong> Showing {filteredData.length} records
                  {startDate && ` from ${startDate.format('MMM DD, YYYY')}`}
                  {endDate && ` to ${endDate.format('MMM DD, YYYY')}`}
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>

        {/* Table Section */}
        <Paper elevation={3}>
          {filteredData.length > 0 ? (
            <>
              <TableContainer>
                <Table sx={{ minWidth: 750 }}>
                  <TableHead>
                    <TableRow sx={{ bgcolor: 'grey.50' }}>
                      <TableCell sx={{ fontWeight: 'bold' }}>Count</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Details</TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>Amount</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Receipt</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Requested</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Paid</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Receipt</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>reversal</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => (
                        <TableRow 
                          key={row.id} 
                          hover
                          sx={{ 
                            '&:nth-of-type(odd)': { bgcolor: 'action.hover' },
                            '&:hover': { bgcolor: 'action.selected' }
                          }}
                        >
                          <TableCell>
                            <Typography variant="body2" fontWeight="medium">
                              {page * rowsPerPage + index + 1}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {formatDateSafe(row.date)}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {row.details}
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="body2" fontWeight="bold" color="primary.light">
                              {formatWithOutSom(row.amount)}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={row.status}
                              color={getStatusColor(row.status)}
                              size="small"
                              variant="filled"
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <ReceiptIcon sx={{ mr: 1, fontSize: 16, color: 'text.secondary' }} />
                              <Typography variant="body2" fontFamily="monospace">
                                {row.receipt}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {row.req_by}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2">
                              {row.paid_by}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => handleEditClick(row.id)}
                              size="small"
                              sx={{ 
                                color: 'primary.main',
                                '&:hover': {
                                  bgcolor: 'primary.light',
                                  color: 'primary.dark'
                                }
                              }}
                            >
                          <SummarizeIcon fontSize="small" />

                          </IconButton>
                          </TableCell>
                                                    <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <Tooltip title="Request reversal">
                                <IconButton
                                  type="button"
                                  onClick={() => openreversal(row)}
                                  size="small"
                                  sx={{ color: 'secondary.main', '&:hover': { bgcolor: 'primary.light', color: 'secondary.main' } }}
                                >
                                  <UndoIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              {pendingReversals.some(r => String(r.receipt) === String(row.receipt)) && (
                                <Tooltip title="Pending reversal — click to view">
                                  <Chip
                                    label="⏳ Pending"
                                    size="small"
                                    color="warning"
                                    variant="outlined"
                                    onClick={() => setReversalNotifOpen(true)}
                                    sx={{ fontSize: '0.65rem', height: 20, cursor: 'pointer', fontWeight: 700 }}
                                  />
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ borderTop: 1, borderColor: 'divider' }}
              />
            </>
          ) : (
            <Box sx={{ textAlign: 'center', py: 8 }}>
              <ReceiptIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
              <Typography variant="h5" color="text.secondary" gutterBottom>
                No records found
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                No billing records match your current filter criteria.
              </Typography>
              <Button variant="contained" onClick={clearFilters} startIcon={<ClearIcon />}>
                Clear All Filters
              </Button>
            </Box>
          )}
        </Paper>
      </Container>
    </LocalizationProvider>
  );
};

  const ActionPanel = () => (
    <Box>
      <Card sx={{ mb: 3 }}>
        <CardHeader title="Billing Actions" />
        <CardContent>
          <Grid container spacing={2}>
            {billingActions.map((action) => {
              const IconComponent = action.icon;
              return (
                <Grid item xs={12} sm={6} md={4} key={action.id}>
                  <Card 
                    variant="outlined" 
                    sx={{ 
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      '&:hover': { 
                        elevation: 4,
                        transform: 'translateY(-2px)'
                      },
                      border: action.urgent ? 2 : 1,
                      borderColor: action.urgent ? 'warning.main' : 'divider',
                      position: 'relative'
                    }}
                  >
                    {action.urgent && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: -8,
                          right: -8,
                          zIndex: 1
                        }}
                      >
                        <Badge badgeContent={<NotificationImportant />} color="warning" />
                      </Box>
                    )}
                    
                    <CardContent>
                      <Box display="flex" alignItems="flex-start" gap={2}>
                        <Avatar sx={{ bgcolor: `${action.color}.main`, color: `${action.color}.contrastText` }}>
                          <IconComponent />
                        </Avatar>
                        <Box flex={1}>
                          <Typography variant="h6" gutterBottom>
                            {action.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {action.description}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </CardContent>
      </Card>

      <Card sx={{ mb: 3 }}>
        <CardHeader title="Account Alerts" />
      </Card>

      <Card sx={{ mb: 3 }}>
        <CardHeader 
          title="Recent Activity" 
          subheader="Latest billing actions for this account"
        />
        <List>
          {recentActivity.map((activity, index) => (
            <React.Fragment key={activity.id}>
              <ListItem>
                <ListItemIcon>
                  <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32 }}>
                    <CheckCircle sx={{ fontSize: 16 }} />
                  </Avatar>
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="body2" fontWeight="600">{activity.action}</Typography>}
                  secondary={<Typography variant="body2" fontWeight="500">{activity.details}</Typography>}
                />
                <Box textAlign="right">
                  {getStatusChip(activity.status)}
                  <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }} fontWeight="600">
                    {formatDateSafe(activity.date)} • {activity.user}
                  </Typography>
                </Box>
              </ListItem>
              {index < recentActivity.length - 1 && <Divider variant="inset" component="li" />}
            </React.Fragment>
          ))}
        </List>
      </Card>

      <Grid container spacing={2}>
        <Grid item xs={6} md={3}>
          <Card sx={{ textAlign: 'center', p: 2 }}>
            <Avatar sx={{ bgcolor: 'success.main', mx: 'auto', mb: 1 }}>
              <AttachMoney />
            </Avatar>
            <Typography variant="h6" fontWeight="bold">GH₵13,100.00</Typography>
            <Typography variant="body2" color="text.secondary" fontWeight="600">Total Collected</Typography>
          </Card>
        </Grid>
        
        <Grid item xs={6} md={3}>
          <Card sx={{ textAlign: 'center', p: 2 }}>
            <Avatar sx={{ bgcolor: 'primary.main', mx: 'auto', mb: 1 }}>
              <Description />
            </Avatar>
            <Typography variant="h6" fontWeight="bold">3</Typography>
            <Typography variant="body2" color="text.secondary" fontWeight="600">Claims Submitted</Typography>
          </Card>
        </Grid>
        
        <Grid item xs={6} md={3}>
          <Card sx={{ textAlign: 'center', p: 2 }}>
            <Avatar sx={{ bgcolor: 'secondary.main', mx: 'auto', mb: 1 }}>
              <Email />
            </Avatar>
            <Typography variant="h6" fontWeight="bold">2</Typography>
            <Typography variant="body2" color="text.secondary" fontWeight="600">Statements Sent</Typography>
          </Card>
        </Grid>
        
        <Grid item xs={6} md={3}>
          <Card sx={{ textAlign: 'center', p: 2 }}>
            <Avatar sx={{ bgcolor: 'warning.main', mx: 'auto', mb: 1 }}>
              <CalendarToday />
            </Avatar>
            <Typography variant="h6" fontWeight="bold">32</Typography>
            <Typography variant="body2" color="text.secondary" fontWeight="600">Days Outstanding</Typography>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!showPaymentModal && !detailDialog.open && (loading || billsLoading || dischargeCheckLoading) && (
  <Backdrop
    sx={{ 
      color: '#fff', 
      zIndex: 1200,
      flexDirection: 'column',
      gap: 2
    }}
    open={true}
  >
    <CircularProgress color="inherit" size={60} />
    <Typography variant="h6" color="inherit">
      {loading ? 'Loading Patient Data...' : dischargeCheckLoading ? 'Checking Discharge Status...' : 'Loading Bills...'}
    </Typography>
  </Backdrop>
)}
      <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', pb: { xs: 10, sm: 0 } }}>
        <Container maxWidth="xl">
          {/* Patient Search */}
          <PatientSearch />
          
          {/* Patient Header */}
          {/* Patient Header */}
<PatientHeader />

{/* ── Reversal Notification Panel ── */}
<ReversalNotificationPanel currentUser={currentUser} />

          {/* Main Content - Now Full Width */}
          <Box 
            sx={{ 
              minHeight: '600px',
              opacity: isReturnedToWard ? 0.5 : 1,
              pointerEvents: isReturnedToWard ? 'none' : 'auto'
            }}
          >
            {activeTab === 0 && (
              <Box>
                <BillingSummary />
                <ChargesTable />
              </Box>
            )}
            {activeTab === 1 && <PaymentHistory />}
            {activeTab === 2 && <ActionPanel />}
          </Box>

          {/* Floating Navigation */}
          <FloatingNavigation />
        </Container>
      </Box>


    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="debit-dialog-title"
    >
      <DialogTitle id="debit-dialog-title">
        Debit Balance / Owing
      </DialogTitle>
      <DialogContent>
        <Alert severity="success" sx={{ mb: 2 }}>
          <AlertTitle>Payment Required</AlertTitle>
          This patient has an outstanding Debit that needs attention.
        </Alert>
        
        <Typography 
          variant="h6" 
          color="error" 
          gutterBottom
          sx={{ textAlign: 'center', my: 2 }}
        >
          Outstanding Debit:{formatCurrency(owing_bal)}
        </Typography>
        
        <Typography variant="body" color="text.secondary">
          Please settle the outstanding balance before proceeding with new services.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Remind Later
        </Button>
        <Button 
          onClick={handlePayOwing}  // CHANGE THIS LINE
          variant="contained" 
          color="primary"
        >
          Make Payment
        </Button>
      </DialogActions>
    </Dialog>



    <PaymentDialog
    open={showPaymentModal}
    onClose={() => setShowPaymentModal(false)}
    allowedPaymentMethods={['cash', 'credit','mobile_money' ,'mobile_money(manual)']}  // Remove 'credit' for debt payments
    defaultPaymentMethod="cash"
    selectedTotal={owingPaymentAmount ? parseFloat(owingPaymentAmount) : selectedTotal}  // Use the entered amount for debt
    selectedPatient={selectedPatient}
    selectedCharges={owingPaymentAmount ? [] : selectedCharges}  // Empty charges for debt payment
    allCharges={allCharges}
    currentUser={currentUser}
    serviceCharges={serviceCharges}
    investigationCharges={investigationCharges}
    medicationCharges={medicationCharges}
    otherCharges={otherCharges}
    isDebtPayment={!!owingPaymentAmount}  // Flag this as debt payment
    paymentType={owingPaymentAmount ? "debt" : "regular"}
    onPaymentSuccess={() => {
      loadBills();
      setSelectedCharges([]);
      setDetailSelectedCharges([]);
      setOwingPaymentAmount('');  // Clear the debt amount
      setOwingPaymentDialogOpen(false);  // Close the dialog
    }}
  />


  <ReversalDialog
  open={showreversModal}
  onClose={() => {
    setshowreversModal(false);
    if (selectedPatient?.id) loadPendingReversals(selectedPatient.id);
  }}
  transactionData={transactionData}
  user={currentUser}
/>


{/* ══════ Pending Reversals Notification Dialog ══════ */}
<Dialog open={reversalNotifOpen} onClose={() => setReversalNotifOpen(false)} maxWidth="md" fullWidth
  PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}>
  <DialogTitle sx={{ p: 0 }}>
    <Box sx={{ background: 'linear-gradient(135deg,#e65100,#ff9800)', color: 'white', px: 3, py: 2.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Badge badgeContent={reversalBadgeCount} color="error">
          <NotificationsActiveIcon sx={{ fontSize: 28 }} />
        </Badge>
        <Box>
          <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1 }}>Pending Reversal Requests</Typography>
          <Typography variant="caption" sx={{ opacity: 0.85 }}>{selectedPatient?.fullName} • Awaiting admin approval</Typography>
        </Box>
      </Box>
      <IconButton onClick={() => setReversalNotifOpen(false)} sx={{ color: 'white' }}><Close /></IconButton>
    </Box>
  </DialogTitle>

  <DialogContent sx={{ p: 0 }}>
    {reversalNotifLoading ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress sx={{ color: '#e65100' }} /></Box>
    ) : pendingReversals.length === 0 ? (
      <Box sx={{ textAlign: 'center', py: 6 }}><Typography color="text.secondary">No pending reversals found.</Typography></Box>
    ) : (
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#fff3e0' }}>
              {['#', 'Date', 'Description', 'Amount', 'Receipt', 'Requested By', 'Status', 'Action'].map(h => (
                <TableCell key={h} sx={{ fontWeight: 700, color: '#e65100', fontSize: '0.75rem' }}>{h}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {pendingReversals.map((rev, idx) => (
              <TableRow key={rev.id} hover sx={{ '&:nth-of-type(odd)': { bgcolor: '#fffde7' } }}>
                <TableCell sx={{ fontSize: '0.75rem', color: '#9e9e9e' }}>{idx + 1}</TableCell>
                <TableCell sx={{ fontSize: '0.8rem' }}>{formatDateSafe(rev.date)}</TableCell>
                <TableCell sx={{ fontSize: '0.8rem', maxWidth: 200 }}>
                  <Typography variant="body2" noWrap fontWeight={600}>{rev.details}</Typography>
                  <Typography variant="caption" color="text.secondary">{rev.charge}</Typography>
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#d32f2f', fontSize: '0.85rem' }}>{formatWithOutSom(rev.amount)}</TableCell>
                <TableCell sx={{ fontSize: '0.78rem', fontFamily: 'monospace' }}>{rev.receipt || '—'}</TableCell>
                <TableCell sx={{ fontSize: '0.78rem' }}>{rev.paid_by}</TableCell>
                <TableCell>
                  <Chip label="Pending" size="small" color="warning" variant="outlined" sx={{ fontWeight: 700, fontSize: '0.7rem' }} />
                </TableCell>
                <TableCell>
                  <Button size="small" variant="contained"
                    startIcon={<ReplayIcon sx={{ fontSize: 14 }} />}
                    onClick={() => {
                      settransactionData({
                        trans_code:  rev.trans_code,
                        amount:      rev.amount,
                        details:     rev.details,
                        table_state: rev.table_state,
                        receipt:     rev.receipt,
                        date:        rev.date,
                        id:          rev.Patient_id,
                        paid_by:     rev.paid_by,
                        req_by:      rev.paid_by,
                        status:      'paid',
                        charge:      rev.charge,
                      });
                      setReversalNotifOpen(false);
                      setshowreversModal(true);
                    }}
                    sx={{ fontSize: '0.68rem', py: 0.4, px: 1.2, bgcolor: '#e65100', fontWeight: 700, '&:hover': { bgcolor: '#bf360c' } }}>
                    Re-submit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </DialogContent>

  <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #f0f0f0' }}>
    <Typography variant="caption" color="text.secondary" sx={{ flex: 1 }}>
      Contact your administrator to approve pending reversals
    </Typography>
    <Button onClick={() => setReversalNotifOpen(false)} variant="outlined">Close</Button>
  </DialogActions>
</Dialog>

    <SimplePaymentAmountDialog
      open={owingPaymentDialogOpen}
      onClose={() => {
        setOwingPaymentDialogOpen(false);
        setOwingPaymentAmount('');
      }}
      patient={{
        name: selectedPatient?.fullName,
        id: selectedPatient?.id,
        balanceDue: owing_bal
      }}
      amount={owingPaymentAmount}
      onAmountChange={setOwingPaymentAmount}
      onProceed={handleProceedToOwingPayment}
      formatCurrency={formatCurrency}
      title="Enter Payment Amount for Owing Balance"
      balanceLabel="Outstanding Debit/Owing Balance"
    />


    <Dialog 
      open={detailDialog.open} 
      onClose={() => setDetailDialog({ open: false, title: '', data: [], tableType: '' })}
      maxWidth="lg" 
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="h6">{detailDialog.title}</Typography>
          <Chip label={`${detailDialog.data.length} items`} size="small" />
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={detailDialog.data.length > 0 && detailDialog.data.every(charge => 
                      detailSelectedCharges.includes(charge.id) || isChargePaid(charge)
                    )}
                    indeterminate={detailDialog.data.some(charge => 
                      detailSelectedCharges.includes(charge.id) && !isChargePaid(charge)
                    ) && !detailDialog.data.every(charge => 
                      detailSelectedCharges.includes(charge.id) || isChargePaid(charge)
                    )}
                    onChange={(e) => {
                      const unpaidCharges = detailDialog.data.filter(charge => !isChargePaid(charge));
                      if (e.target.checked) {
                        const unpaidIds = unpaidCharges.map(charge => charge.id);
                        setDetailSelectedCharges([...new Set([...detailSelectedCharges, ...unpaidIds])]);
                        setSelectedCharges([...new Set([...selectedCharges, ...unpaidIds])]);
                      } else {
                        const unpaidIds = unpaidCharges.map(charge => charge.id);
                        setDetailSelectedCharges(detailSelectedCharges.filter(id => !unpaidIds.includes(id)));
                        setSelectedCharges(selectedCharges.filter(id => !unpaidIds.includes(id)));
                      }
                    }}
                    
                    disabled={detailDialog.data.every(charge => !isChargeSelectable(charge))}
                  />
                </TableCell>
                <TableCell align="center"><Typography variant="body2" fontWeight="bold">Receipt</Typography></TableCell>
                <TableCell><Typography variant="body2" fontWeight="bold">Date</Typography></TableCell>
                <TableCell><Typography variant="body2" fontWeight="bold">Code</Typography></TableCell>
                <TableCell><Typography variant="body2" fontWeight="bold">Description</Typography></TableCell>
                <TableCell align="right"><Typography variant="body2" fontWeight="bold">Amount</Typography></TableCell>
                <TableCell align="center"><Typography variant="body2" fontWeight="bold">Status</Typography></TableCell>
                <TableCell><Typography variant="body2" fontWeight="bold">Receipt No.</Typography></TableCell>
                <TableCell><Typography variant="body2" fontWeight="bold">Requested By.</Typography></TableCell>
                <TableCell><Typography variant="body2" fontWeight="bold">Cashier</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detailDialog.data.map((charge) => (
                <TableRow
                  key={charge.id}
                  sx={{
                    bgcolor: isChargePaid(charge) ? '#f0f8f0' : 'inherit',
                    '&:hover': { 
                      bgcolor: isChargePaid(charge) ? '#f0f8f0' : 'grey.50',
                    },
                  }}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={detailSelectedCharges.includes(charge.id) || isChargePaid(charge)}
                     onChange={(e) => handleDetailCheckboxChange(charge.id, e.target.checked)}
                      disabled={!isChargeSelectable(charge)}
                    />
                  </TableCell>

                  <TableCell align="center">
                    
                   <IconButton 
                    size="small" 
                    color="primary"
                    onClick={() => {
                      const receiptKey = String(charge.receipt ?? '').trim();

                      const receiptCharges = detailDialog.data.filter(
                        c => String(c.receipt ?? '').trim() === receiptKey
                      );

                      const receiptTotal = receiptCharges.reduce(
                        (sum, c) => sum + (Number(c.total) || 0),
                        0
                      );

                      const paidTotal = receiptCharges
                        .filter(c => {
                          const s = (c.status ?? '').toString().toLowerCase();
                          return s === 'paid' || s === 'credit';
                        })
                        .reduce((sum, c) => sum + (Number(c.total) || 0), 0);

                      const debtPayment = receiptTotal - paidTotal;

                      const receiptData = {
                        patientId: selectedPatient.id,
                        patientName: selectedPatient.fullName,
                        receipt: charge.receipt,
                        time: charge.time,
                        description: 'Dept Payment',
                        total: Number(receiptTotal).toFixed(2), 
                        paid: Number(paidTotal).toFixed(2), 
                        debt: Number(debtPayment).toFixed(2),
                        charges: receiptCharges,
                        status: charge.status,
                        paymentMode: charge.state || 'Cash',
                        user: charge.user
                      };

                      setReceiptDialog({ open: true, receiptData });
                    }}
                    disabled={!isChargePaid(charge) || (charge.status ?? '').toLowerCase() === 'credit'}
                    sx={{ 
                      '&:hover': { 
                        bgcolor: isChargePaid(charge) ? 'primary.main' : 'transparent', 
                        color: isChargePaid(charge) ? 'white' : 'text.disabled',
                        '& .MuiSvgIcon-root': {
                          color: isChargePaid(charge) ? 'white' : 'text.disabled'
                        }
                      },
                      '&.Mui-disabled': {
                        color: 'text.disabled',
                        cursor: 'not-allowed'
                      }
                    }}
                  >
                    <Receipt fontSize="small" />
                  </IconButton>


                  </TableCell>

                  <TableCell>
                    <Typography variant="body2">
                      {charge.time}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {charge.code}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {charge.description}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography fontWeight="bold">
                      {formatWithOutSom(charge.total)}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    {getStatusChip(charge.status)}
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2">
                      {charge.receipt}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2">
                      {charge.doc_name}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2">
                      {charge.user}
                    </Typography>
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* Summary section */}
        <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="h6" gutterBottom>Summary</Typography>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">Total Items:</Typography>
              <Typography variant="h6">{detailDialog.data.length}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">Total Amount:</Typography>
              <Typography variant="h6">
                GH₵{detailDialog.data.reduce((sum, charge) => sum + (parseFloat(charge.total) || 0), 0).toFixed(2)}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body2" color="text.secondary">Selected:</Typography>
              <Typography variant="h6" color="primary.main">
                GH₵{detailDialog.data
                  .filter(charge => detailSelectedCharges.includes(charge.id))
                  .reduce((sum, charge) => sum + (parseFloat(charge.total) || 0), 0)
                  .toFixed(2)}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button 
          onClick={() => setDetailDialog({ open: false, title: '', data: [], tableType: '' })}
        >
          Close
        </Button>
        {detailSelectedCharges.length > 0 && (
          <Button 
            variant="contained" 
            onClick={() => {
              setDetailDialog({ open: false, title: '', data: [], tableType: '' });
              setShowPaymentModal(true);
            }}
          >
            Process Selected ({detailSelectedCharges.length})
          </Button>
        )}
      </DialogActions>
      
      {/* Thermal Receipt Dialog */}
      <ThermalReceipt 
        open={receiptDialog.open}
        onClose={() => setReceiptDialog({ open: false, receiptData: null })}
        receiptData={receiptDialog.receiptData}
      />
    </Dialog>


    </ThemeProvider>
  );

};
  
export default PatientBill;